import { render, staticRenderFns } from "./NoUser.vue?vue&type=template&id=5d837ed8&"
import script from "./NoUser.vue?vue&type=script&lang=js&"
export * from "./NoUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports